import React from "react";
import { MAILHOG } from "./simulab";

/** Qué es cada correo según dónde quedó registrado */
const NOMBRES = { SOLICITU: "Solicitud de la instrucción", CONSTANC: "Constancia de entrega al cliente", ENVIODOC: "Documentos al transportador", PAQUETEX: "Paquete al depósito" };
/** Estado del correo dicho en simple */
const ESTADOS = { ENVIADO: "enviado", SIMULADO: "simulado (no salió: falta el buzón de pruebas)", ENVIANDO: "enviándose", FALLIDO: "falló", SIN_DESTINATARIO: "sin destinatario" };

/**
 * Correos de la entrega: los que CIMA dejó anotados en la tarea y los que llegaron a MailHog con el número del DO.
 * @param {object} props
 * @param {object} props.foto Respuesta de /laboratorio/quePaso (CORREOS, MAILHOG)
 * @author Claude Code (Alexandra Parra) <direccionit.siaco@repremundo.com.co>
 * @since 2026-10-26
 */
const Qpcorreo = ({ foto }) => {
  const correos = foto.CORREOS ?? [];
  const mailhog = foto.MAILHOG ?? {};
  return (
    <div className="sim-qp-caja">
      <div className="sim-qp-frase">{correos.length ? `Correos de la entrega: ${correos.length}` : "CIMA aún no ha mandado correos de esta entrega"}</div>
      {correos.map((m, i) => (
        <span key={`${m.DONDEXXX}-${i}`}>
          {`${nombreCorreo(m.DONDEXXX)}: ${ESTADOS[m.ESTADOXX] ?? m.ESTADOXX}${m.PARAXXXX ? ` · para ${m.PARAXXXX}` : ""}${m.FECHAXXX ? ` · ${m.FECHAXXX} ${m.HORAXXXX}` : ""}`}
        </span>
      ))}
      <span className="sim-qp-nota">
        {mailhog.DISPONIBLE ? `MailHog tiene ${mailhog.TOTAL} correo(s) que mencionan este DO. ` : "MailHog no respondió. "}
        <a className="sim-enlace" href={MAILHOG} target="_blank" rel="noreferrer">Abrir MailHog</a>
      </span>
    </div>
  );
};

/**
 * Nombre del correo a partir de dónde quedó anotado (INSTRENT.SOLICITU, INSTRENT.CONSTANC.12, ...).
 * @param {string} donde Ruta en el diccionario de la tarea
 * @returns {string}
 */
const nombreCorreo = (donde) => {
  const clave = Object.keys(NOMBRES).find((c) => `${donde}`.split(".").includes(c));
  return clave ? NOMBRES[clave] : donde || "Correo";
};

export default Qpcorreo;
